import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const LegendContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '24px',
  marginBottom: '16px',
});

const LegendItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

const ColorBox = styled(Box)({
  width: '18px',
  height: '18px',
  borderRadius: '4px',
});

const Legend = ({ items }) => {
  return (
    <LegendContainer>
      {items.map((item, index) => (
        <LegendItem key={index}>
          <ColorBox style={{ backgroundColor: item.color }} />
          <Typography variant="body2">{item.label}</Typography>
        </LegendItem>
      ))}
    </LegendContainer>
  );
};

export default Legend;